import { render, staticRenderFns } from "./ProgramContentHeader.vue?vue&type=template&id=2d96fa88&scoped=true&"
import script from "./ProgramContentHeader.vue?vue&type=script&lang=js&"
export * from "./ProgramContentHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProgramContentHeader.vue?vue&type=style&index=0&id=2d96fa88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d96fa88",
  null
  
)

export default component.exports